module.exports = __webpack_public_path__ + "img/treatments-directory-dashboard-desktop-en.b8451c5c.jpg";